import { t, type TranslationKey } from '@/shared/lib/i18n'

const REVIEW_DECISION_OPTION_KEYS: Record<string, TranslationKey> = {
  ODE: 'compliance.dashboard.reviewDecision.overrideOption',
  CNM: 'compliance.dashboard.reviewDecision.confirm',
  NPT: 'compliance.dashboard.reviewDecision.notPerformed',
  OFL: 'compliance.dashboard.reviewDecision.offline',
}

export const reviewDecisionOptionLabel = (
  code: string | null | undefined,
  fallbackLabel: string,
): string => {
  if (!code) return fallbackLabel
  const key = REVIEW_DECISION_OPTION_KEYS[code]
  return key ? t(key) : fallbackLabel
}
